module.exports = __webpack_public_path__ + "img/logo.28cda86a.png";